import type { HandleErrorOptions } from '@/types/error.types'
import router from '@/router'
import { AxiosError } from 'axios'
import rg4js from 'raygun4js'

export function handleError(options: HandleErrorOptions): void {
  const { error, action } = options

  // checking for promise error on 401s before interceptor does its job
  if (error === 'Error' || error === undefined) return

  // double check for 401 errors from Axios
  if (isAxiosError(error) && error.response && error.response.status === 401) {
    // should not make it here. Axios response interceptor should handle 401 errors, so just send the user to logout
    router.push('logout')

    return
  }

  // checks to see if user is offline
  if (isErrorObj(error) && error.message === 'Network Error') return

  // send to raygun
  if (isErrorObj(error)) {
    rg4js('send', {
      error: error,
      customData: [{ action }]
    })

    return
  }

  rg4js('send', {
    error: new Error(`Error not formatted correctly: ${error}`),
    customData: [{ action }]
  })
}

export function isAxiosError(error: unknown): error is AxiosError {
  return error instanceof AxiosError
}

export function isErrorObj(error: unknown): error is Error {
  return error && typeof error === 'object' ? 'name' in error && 'message' in error : false
}

export function hasInternalErrorCode(
  error: unknown
): error is AxiosError<{ internalErrorCode: number; message?: string }> {
  return (
    isAxiosError(error) &&
    error.response !== undefined &&
    typeof error.response.data === 'object' &&
    error.response.data !== null &&
    'internalErrorCode' in error.response.data
  )
}
